import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";



import { CandidateStoryComponent } from "./candidate-story/candidate-story.component";
import { VideosWrapperComponent } from "./candidate-story/videos-wrapper.component";
import { BunnyVideosComponent } from "./bunny-videos/bunny-videos.component";
import { ReflectionComponent } from "./reflection/reflection.component";

import { SurveyComponent } from "./survey/survey.component";
import { FinishedComponent } from "./finished/finished.component";
import { SharedModule } from "../shared/shared.module";
import { AddActionComponent } from './add-action/add-action.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [

    CandidateStoryComponent,
    VideosWrapperComponent,
    BunnyVideosComponent,
    ReflectionComponent,

    SurveyComponent,
    FinishedComponent,
    AddActionComponent
  ]
})
export class ResultModule {}
